import { ReactNode, useCallback } from "react";
import { FCX, MacStageLabel, HeatScoreLabel } from "@datassential/platform-ui-lib";
import cn from "classnames";
import "./LabeledList.styles.scss";

interface ListItem {
    id: number;
    name: string;
    description: string;
}

type ListType = 'macStages' | 'heatScores';

interface LabeledListProps {
    items: ListItem[];
    title?: string | ReactNode;
    type?: ListType;
    className?: string;
}

const LabeledList: FCX<LabeledListProps> = ({ items, type, title, className }) => {
    const labelRenderers = {
        macStages: (item: ListItem) => <MacStageLabel macStages={items} macStageId={item.id} modifiers={['medium']} />,
        heatScores: (item: ListItem) => <HeatScoreLabel heatScores={items} heatScoreId={item.id} modifiers={['medium']} />
    };

    const renderLabel = useCallback((item: ListItem) => {
        if (!type) return item.name;
        return labelRenderers[type]?.(item) || item.name;
    }, [items, type]);

    return (
        <div className={cn("LabeledList", className)}>
            {title && <div className="LabeledList__title">{title}</div>}
            {items.map((item) => (
                <div key={item.id} className="LabeledList__item">
                    <div className="LabeledList__label">
                        {renderLabel(item)}
                    </div>
                    <div className="LabeledList__description">
                        {item.description}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default LabeledList;